import { storyblokEditable } from '@storyblok/react/rsc';
import clsx from 'clsx';
import { HTMLInputTypeAttribute } from 'react';
import PhoneInput from 'react-phone-number-input';

import 'react-phone-number-input/style.css';
import commonStyles from '../Common.module.scss';

import { Typography } from '@/components/core';
import { InputFormStoryblok } from '@/types/storyblok/storyblok-types';

import styles from './InputPhone.module.scss';

type InputPhoneProps = {
    blok: InputFormStoryblok;
    props: any;
    type?: HTMLInputTypeAttribute;
    error?: any | null;
    isTouched?: boolean;
    required?: boolean;
    className?: string;
};

export const InputPhone: React.FC<InputPhoneProps> = ({ blok, props, error, required, isTouched, className }) => {
    const { label, placeholder, width } = blok;

    return (
        <div
            {...storyblokEditable(blok)}
            className={clsx(commonStyles.root, styles.InputPhone, {
                [commonStyles.halfWidth]: width === '50%',
            })}
        >
            <div>
                <label className={clsx(commonStyles.label, 'label')}>{label}</label>
                {required && <span className={commonStyles.asterix}>*</span>}
            </div>

            <PhoneInput
                countryCallingCodeEditable={false}
                className={clsx(commonStyles.input, styles.test, className)}
                placeholder={placeholder}
                {...props}
            />

            {error && isTouched && (
                <Typography
                    looksLike="pSmall"
                    className={styles.error}
                >
                    {error.message}
                </Typography>
            )}
        </div>
    );
};
